import './index.css';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useTheme from '../../../utilities/hooks/theme';
import View from '../../view';
import Text from '../../text';

const FantasyPlaceHolder = () => {
  const { sportsFactsData } = useSelector((state: any) => state.app);
  const { factsList = [] }: { factsList: Array<string> } = sportsFactsData;
  const { DefaultTheme } = useTheme();
  const [randomFact, setRandomFact] = useState('');
  const [showFact, setShowFact] = useState(false);

  const getRandomInt = (min: number, max: number) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  useEffect(() => {
    if (factsList.length > 0) {
      const randomNumber: any = getRandomInt(0, factsList.length - 1);
      setRandomFact(factsList[randomNumber]);
    }
    let timer1 = setTimeout(() => {
      setShowFact(true);
    }, 300);

    return () => {
      clearTimeout(timer1);
    };
  }, []);

  const factText = {
    color: DefaultTheme.placeholderFactText
  };

  const factViewDivider = {
    backgroundColor: DefaultTheme.placeholderFactText
  };

  return (
    <View className="fantasy-placeholder-container">
      {showFact && (
        <View className="fantasy-placeholder-fact-container">
          <Text className="fantasy-placeholder-text" style={factText}>
            {randomFact}
          </Text>
          <View style={factViewDivider} className="fantasy-placeholder-divider" />
        </View>
      )}
    </View>
  );
};
export default FantasyPlaceHolder;
